import axios from 'axios';
import { notifyUnauthorized } from './authEvents';

// The enrichment agents: start research, see how it went, and decide on what they found
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || '',
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' }
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) notifyUnauthorized();
    return Promise.reject(error);
  }
);

const call = async (request, fallbackMessage) => {
  try {
    return (await request()).data;
  } catch (error) {
    const detail = error.response?.data?.detail;
    throw new Error(typeof detail === 'string' ? detail : fallbackMessage);
  }
};

const enrichmentApi = {
  status: () => call(() => apiClient.get('/api/v2/enrichment/status'), "Couldn't load the agents' status"),
  runs: () => call(() => apiClient.get('/api/v2/enrichment/runs'), "Couldn't load the runs"),
  waitingForReview: () => call(() => apiClient.get('/api/v2/enrichment/findings'), "Couldn't load the findings"),
  sweep: () => call(() => apiClient.post('/api/v2/enrichment/sweep'), "Couldn't start the agents"),
  // ids, or filters: an Ask Sinatra search, whose people without a location get researched.
  // kind: 'research' (default) or 'site_audit'.
  startRun: (subjectType, { ids, filters, kind }) => call(
    () => apiClient.post('/api/v2/enrichment/runs', { subject_type: subjectType, ids, filters, kind }),
    "Couldn't start the agents"),
  getRun: (runId) => call(() => apiClient.get(`/api/v2/enrichment/runs/${runId}`), "Couldn't check on the run"),
  // kind narrows last_task to one kind of run, for a caller that only cares about its own.
  subject: (subjectType, id, kind) => call(
    () => apiClient.get(`/api/v2/enrichment/subjects/${subjectType}/${id}`, { params: kind ? { kind } : undefined }),
    "Couldn't check on the agents"),
  accept: (id) => call(() => apiClient.post(`/api/v2/enrichment/findings/${id}/accept`), "Couldn't save that"),
  reject: (id) => call(() => apiClient.post(`/api/v2/enrichment/findings/${id}/reject`), "Couldn't save that")
};

export default enrichmentApi;
